<app-nav></app-nav>
<app-top-header [showMonthControl]="false" [pageTitle]="'page.subscription'"></app-top-header>

<div class="subscription-wrapper">
  <div class="subscription-shell">
    <section class="subscription-hero">
      <div class="hero-topline">
        <div class="eyebrow">{{ 'subscription.eyebrow' | t:'Flat based plans' }}</div>
        <span class="subscription-hero-status" *ngIf="isCurrentPackageTrial()">Trial Active</span>
      </div>
      <h1>{{ 'subscription.title' | t:'Choose a subscription plan' }}</h1>
      <p>
        {{ heroSubtitleLead() }}
        <ng-container *ngIf="heroSubtitleTrailLead() || heroSubtitleTrailHighlight() || heroSubtitleTrailSuffix()">
          <span class="subscription-hero-trail-lead" *ngIf="heroSubtitleTrailLead()">{{ heroSubtitleTrailLead() }}</span>
          <span class="subscription-hero-trial" *ngIf="heroSubtitleTrailHighlight()">{{ heroSubtitleTrailHighlight() }}</span>
          <span class="subscription-hero-trail-lead" *ngIf="heroSubtitleTrailSuffix()">{{ heroSubtitleTrailSuffix() }}</span>
        </ng-container>
      </p>
    </section>

    <div class="subscription-message" *ngIf="isLoading">{{ 'subscription.loading' | t:'Loading subscription info...' }}</div>
    <div class="subscription-message error" *ngIf="!isLoading && error">{{ error }}</div>

    <section class="plan-grid" *ngIf="displayPackages.length > 0">
      <article class="plan-card" *ngFor="let plan of displayPackages" [class.current-package]="isCurrentPackage(plan)" [class.custom-card]="isCustomCard(plan)">
        <div class="plan-card-header">
          <h2>{{ plan.packageName }}</h2>
          <div class="plan-current-badge" *ngIf="isCurrentPackage(plan)">{{ 'subscription.currentPackage' | t:'Current Package' }}</div>
        </div>
        <p class="plan-custom-description" *ngIf="isCustomCard(plan) && !isCurrentPackage(plan)">{{ localize(plan.customDescription) }}</p>
        <div class="custom-capability-list" *ngIf="isCustomCard(plan) && !isCurrentPackage(plan)">
          <div class="custom-capability-item">
            <span class="custom-capability-label">{{ 'subscription.flats' | t:'Active flats' }}</span>
            <span class="custom-capability-value">{{ 'subscription.customAsNeeded' | t:'As needed' }}</span>
          </div>
          <div class="custom-capability-item">
            <span class="custom-capability-label">{{ 'subscription.renters' | t:'active renters' }}</span>
            <span class="custom-capability-value">{{ 'subscription.customAsNeeded' | t:'As needed' }}</span>
          </div>
          <div class="custom-capability-item">
            <span class="custom-capability-label">{{ 'subscription.subusers' | t:'subusers' }}</span>
            <span class="custom-capability-value">{{ 'subscription.customAsNeeded' | t:'As needed' }}</span>
          </div>
          <div class="custom-capability-item">
            <span class="custom-capability-label">{{ 'subscription.storage' | t:'file storage' }}</span>
            <span class="custom-capability-value">{{ 'subscription.customAsNeeded' | t:'As needed' }}</span>
          </div>
        </div>
        <div class="plan-price-stack" *ngIf="!isFreePlan(plan) && !isCustomCard(plan); else alternatePlanInfo">
          <div class="plan-price-row">
            <span class="plan-price">{{ formatPrice(plan.priceMonthly) }}</span>
            <small>/ month</small>
          </div>
          <div class="plan-price-row yearly">
            <span class="plan-price">{{ formatPrice(plan.priceYearly) }}</span>
            <small>/ year</small>
          </div>
          <div class="plan-saving" *ngIf="plan.priceYearly > 0">{{ 'subscription.yearlySave' | t:'Save 2 months bill' }}</div>
        </div>
        <ng-template #alternatePlanInfo>
          <div class="plan-free-note" *ngIf="isFreePlan(plan) && !isCustomCard(plan)">{{ 'subscription.freePlan' | t:'Free forever' }}</div>
        </ng-template>
        <ng-container *ngIf="!isCustomCard(plan) || isCurrentPackage(plan)">
          <div class="plan-count">{{ plan.totalFlat }}</div>
          <div class="plan-label">{{ 'subscription.flats' | t:'Active flats' }}</div>
          <div class="plan-meta">{{ plan.totalRenter }} {{ 'subscription.renters' | t:'active renters' }}</div>
          <div class="plan-meta">{{ formatSubuserCount(plan.maxActiveEmployee) }}</div>
          <div class="plan-meta">{{ formatStorage(plan.maxFileMemory) }} {{ 'subscription.storage' | t:'file storage' }}</div>
          <div class="plan-expire-meta" *ngIf="currentPackageExpireDate(plan)">
            <span class="plan-expire-label" *ngIf="currentPackageExpireDate(plan)">{{ 'subscription.packageExpireDate' | t:'Package Expire Date' }}</span>
            <div class="plan-expire-row">
              <span class="plan-expire-value" *ngIf="currentPackageExpireDate(plan)">{{ currentPackageExpireDate(plan) }}</span>
            </div>
          </div>
        </ng-container>
      </article>
    </section>
    <div class="subscription-message" *ngIf="!isLoading && !error && displayPackages.length === 0">{{ 'entityList.empty' | t:'No data found.' }}</div>

    <section class="contact-card">
      <h2>{{ 'subscription.contactTitle' | t:'Contact for subscription' }}</h2>
      <p>{{ 'subscription.contactSubtitle' | t:'Use WhatsApp, mobile, or email for subscription activation or upgrade support. Payment methods will be added in the future.' }}</p>

      <div class="contact-grid">
        <div>
          <h3>{{ 'subscription.whatsapp' | t:'WhatsApp / Mobile' }}</h3>
          <div *ngFor="let mobile of contactInfo.mobileWhatsapp" class="contact-row">
            <a class="contact-link" [href]="telHref(mobile)">
              {{ mobile }}
            </a>
            <div class="contact-actions">
              <a
                class="contact-icon-btn whatsapp-btn"
                [href]="whatsappHref(mobile)"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="'subscription.whatsapp' | t:'WhatsApp'"
                title="WhatsApp"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M12 2.2a9.8 9.8 0 0 0-8.4 14.85L2 22l5.1-1.57A9.8 9.8 0 1 0 12 2.2Zm0 17.84c-1.55 0-3.06-.4-4.4-1.15l-.31-.18-3.03.93.98-2.95-.2-.31a8.04 8.04 0 1 1 6.96 3.66Zm4.41-5.44c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.02-.37-1.94-1.18-.72-.64-1.2-1.42-1.34-1.66-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.49-.4-.42-.54-.43h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.64.58.25 1.04.4 1.39.51.58.18 1.11.15 1.53.09.47-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28Z"/>
                </svg>
              </a>
              <button
                type="button"
                class="contact-copy-btn"
                (click)="copyContact(mobile, 'mobile')"
              >
                {{ isContactCopied(mobile, 'mobile') ? ('common.copied' | t:'Copied') : ('common.copy' | t:'Copy') }}
              </button>
            </div>
          </div>
        </div>

        <div>
          <h3>{{ 'subscription.email' | t:'Email' }}</h3>
          <div *ngFor="let email of contactInfo.email" class="contact-row">
            <a class="contact-link" [href]="mailtoHref(email)">
              {{ email }}
            </a>
            <div class="contact-actions">
              <button
                type="button"
                class="contact-copy-btn"
                (click)="copyContact(email, 'email')"
              >
                {{ isContactCopied(email, 'email') ? ('common.copied' | t:'Copied') : ('common.copy' | t:'Copy') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
